<div class="audit-trail-changes-container">

  <cs-table-nxt [data]="metaData">
  </cs-table-nxt>

  <cs-table-nxt [data]="data">
  </cs-table-nxt>
</div>